import { inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { Store } from "@ngrx/store";
import { FromRouter, RootState } from "src/app/store";
import { Router, UrlTree } from "@angular/router";
import { AppRoutes, INVALID_PROGRAMS, LIMIT_PROGRAM_CHARS } from "src/app/constants";

@Injectable({ providedIn: "root" })
export class CheckProgramGuard {
  private readonly store = inject(Store<RootState>);
  private readonly router = inject(Router);

  private readonly programId$: Observable<string | undefined> = this.store.select(FromRouter.selectProgramId);

  public canActivate(): Observable<boolean | UrlTree> {
    return this.programId$.pipe(
      map(programId => {
        const programOnSubdomain = this.getSubdomainProgram();

        if ((programId && programOnSubdomain && programId !== programOnSubdomain) || (programOnSubdomain && !programId)) {
          return this.router.createUrlTree([AppRoutes.root, programOnSubdomain]);
        }

        return true;
      }),
    );
  }

  private getSubdomainProgram(): string | null {
    const url = new URL(window.location.href);

    const subdomain = url.hostname.split(".").shift();

    if (subdomain && !INVALID_PROGRAMS.some(invalidProgram => invalidProgram === subdomain) && subdomain.length < LIMIT_PROGRAM_CHARS) {
      return subdomain;
    }

    return null;
  }
}
